import type { DocumentItem } from 'src/components/pages/info/document/index/types'

type Translate = (_text: string) => string

export default function getPdDocuments(staticPath: string, translate: Translate): DocumentItem[] {
  const base = `${staticPath}_v1/pd/documents/organization`

  return [
    {
      id: 'inn-medrating',
      title: translate('ИНН ООО "МедРейтинг"'),
      alt: translate('ИНН ООО "МедРейтинг"'),
      previewSrc: `${base}/inn-medrating-sm.png`,
      src: `${base}/inn-medrating.png`,
    },
    {
      id: 'ogrn-medrating',
      title: translate('ОГРН ООО "МедРейтинг"'),
      alt: translate('ОГРН ООО "МедРейтинг"'),
      previewSrc: `${base}/ogrn-medrating-sm.png`,
      src: `${base}/ogrn-medrating.png`,
    },
    {
      id: 'tm-prodoctorov-2013',
      title: translate('Товарный знак "ПроДокторов"'),
      alt: translate('Товарный знак "ПроДокторов"'),
      previewSrc: `${base}/tm-prodoctorov-2013-sm.png`,
      src: `${base}/tm-prodoctorov-2013.png`,
    },
    {
      id: 'tm-prodoctorov-2018',
      title: translate('Товарный знак "ProDoctorov"'),
      alt: translate('Товарный знак "ProDoctorov"'),
      previewSrc: `${base}/tm-prodoctorov-2018-sm.png`,
      src: `${base}/tm-prodoctorov-2018.png`,
    },
    {
      id: 'tm-medrocket',
      title: translate('Товарный знак "МедРокет"'),
      alt: translate('Товарный знак "МедРокет"'),
      previewSrc: `${base}/tm-medrocket-sm.jpg`,
      src: `${base}/tm-medrocket.jpg`,
    },
    {
      id: 'smi-prodoctorov',
      title: translate('Свидетельство о регистрации СМИ ПроДокторов'),
      alt: translate('Свидетельство о регистрации СМИ ПроДокторов'),
      previewSrc: `${base}/smi-prodoctorov-sm.png`,
      src: `${base}/smi-prodoctorov.png`,
    },
    {
      id: 'bd-prodoctorov',
      title: translate('Свидетельство о государственной регистрации баз данных'),
      alt: translate('Свидетельство о государственной регистрации баз данных'),
      previewSrc: `${base}/bd-prodoctorov-sm.jpg`,
      src: `${base}/bd-prodoctorov.jpg`,
    },
    {
      id: 'pd-prodoctorov',
      title: translate('Продление товарного знака "ПроДокторов"'),
      alt: translate('Продление товарного знака "ПроДокторов"'),
      previewSrc: `${base}/pd-prodoctorov-sm.jpg`,
      src: `${base}/pd-prodoctorov.jpg`,
    },
  ]
}
